var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.86881 1.72283L7.75012 3.49727C7.86888 3.74267 8.18765 3.97549 8.45642 4.02583L10.0503 4.2901C11.0691 4.46 11.3066 5.20249 10.5753 5.94498L9.33148 7.19716C9.12521 7.4048 9.00646 7.81381 9.07521 8.10955L9.43148 9.65746C9.71275 10.8782 9.06271 11.3564 7.99389 10.7146L6.50003 9.82106C6.23127 9.65746 5.78124 9.65746 5.51247 9.82106L4.01862 10.7146C2.94979 11.3501 2.29975 10.8782 2.58102 9.65746L2.93729 8.10955C2.99355 7.80751 2.87479 7.39851 2.66852 7.19087L1.42469 5.93869C0.693388 5.20249 0.930904 4.46 1.94972 4.28381L3.54358 4.01953C3.81235 3.97549 4.13112 3.73638 4.24988 3.49098L5.13119 1.71654C5.61247 0.760107 6.38753 0.760107 6.86881 1.72283Z",
    fill: "#FFB200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1a9e3bf011a72041fcde25ff2c663324.svg";
export { ForwardRef as ReactComponent };